import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'batch-send-pending-list-notification',
  templateUrl: './batch-send-pending-notification.component.html',
  styleUrls: ['./batch-send-pending-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BatchSendPendingNotificationComponent {
  @Input() public header: string;
  @Input() public hint: string;
}
